import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import IntlMessages from '../../components/IntlMessage';
import { Button, Card, Table, Modal, Row, Col, Space, Typography } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import PageTitle from '../../components/PageTitle';
import _, { debounce } from 'lodash';
import { useIntl } from 'react-intl';
import ActionBar from '../../components/ActionBar';
import FilterBar from '../../components/FilterBar';
import UsersForm from './usersForm';
import usersApi from '../../api/users';
import { useSelector } from 'react-redux';
import { Roles } from '../../utils/constant';
import dayjs from 'dayjs';

const { Text } = Typography;
UsersAdmin.propTypes = {
  items: PropTypes.array,
};
UsersAdmin.defaultProps = {
  items: [],
};

function UsersAdmin(props) {
  // const isMount = useRef(false)
  const authUser = useSelector((state) => state.auth.authUser);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(1);
  const [item, setItem] = useState(null);
  // const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(true);
  const [condition, setCondition] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    keyword: '',
    order_by: 'id',
    order_dir: 'DESC',
    filter_name: ['roles'],
    filter_value: [['admin', 'super']],
  });
  const [modal, setModal] = useState(false);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      let items = await usersApi.getAll(filter);
      let data = items.data;
      // console.log(' list users', data);

      setItems(data);
      setLoading(false);
      // setDeleting(false);
      if (total !== items.total) setTotal(items.total);
    }
    fetchData();
  }, [filter, reload, authUser]);

  useEffect(() => {
    if (filter?.filter_name && filter?.filter_value) {
      const newCondition = _.zipObjectDeep(
        filter?.filter_name,
        filter?.filter_value
      );
      setCondition(newCondition);
    }
  }, [filter]);

  const onChangeTable = async (
    pagination,
    filters,
    sorter,
    extra = { currentDataSource: [] }
  ) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
      order_dir: getOrder(sorter.order),
      order_by: sorter.columnKey ? `${sorter.columnKey}` : 'id',
    });
  };

  const onFilter = debounce(async (value, title, type) => {
    if (type === 'search') {
      setFilter((filter) => {
        return { ...filter, keyword: value, page: 1 };
      });
    } else {
      const filter_obj = { ...condition, [title]: value };
      let filter_name = [];
      let filter_value = [];
      for (var key in filter_obj) {
        if (filter_obj[key]) {
          filter_name.push(key);
          filter_value.push(filter_obj[key]);
        }
      }
      setFilter((filter) => {
        return {
          ...filter,
          filter_name: filter_name,
          filter_value: filter_value,
        };
      });
    }
  }, 300);

  const onReload = () => {
    setReload((reload) => !reload);
  };

  const onOpenModal = (record = null) => {
    setModal(true);
    setItem(record);
    // console.log(record);
  };

  const onCloseModal = () => {
    setModal(false);
  };
  const intl = useIntl();

  const getOrder = (order) => {
    if (order === 'ascend') return 'ASC';
    if (order === 'descend') return 'DESC';
    return 'DESC';
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onDelete = async (selectedRowKeys) => {
    // console.log('Deleted');
    await usersApi.delete(selectedRowKeys).catch((error) => {
      console.error(error);
      Modal.error({
        title: error.data.message,
        okText: intl.formatMessage({ id: 'global.close' }),
      });
      setLoading(false);
    });
    setSelectedRowKeys([]);
    // setDeleting(true);
    onReload();
  };

  const columns = [
    {
      title: <IntlMessages id="global.id" />,
      width: 20,
      render: (text, record, index) => {
        return record.id;
      },
    },

    {
      title: <IntlMessages id="global.firstname" />,
      key: 'firstname',
      sorter: true,

      dataIndex: 'firstname',
      render: (text, record) => {
        //return `${record.firstname}`;
        return (
          <Button
            type="link"
            size="small"
            onClick={() => onOpenModal(record)}
            shape="round">
            {record.firstname}
          </Button>
        );
      },
    },

    {
      title: <IntlMessages id="global.lastname" />,
      key: 'lastname',
      sorter: true,

      dataIndex: 'lastname',
      render: (text, record) => {
        return `${record.lastname}`;
      },
    },

    {
      title: <IntlMessages id="global.email" />,
      key: 'email',
      sorter: true,

      dataIndex: 'email',
      render: (text, record) => {
        return (
          <p>
            {record.email}{' '}
            {record.is_verified ? (
              <CheckCircleOutlined style={{ color: 'green' }} />
            ) : null}
          </p>
        );
      },
    },

    {
      title: <IntlMessages id="global.phone" />,
      key: 'mobile',
      sorter: true,

      dataIndex: 'mobile',
      render: (text, record) => {
        return (
          <p>
            {record.mobile}{' '}
            {record.is_mobile_verified ? <CheckCircleOutlined /> : null}
          </p>
        );
      },
    },

    {
      title: <IntlMessages id="global.created_at" />,
      key: 'created_at',
      dataIndex: 'created_at',
      render: (text, record, index) => {
        return (
          <Space size={2} direction="vertical">
            <Text>{dayjs(record?.created_at).format('DD/MM/YYYY')}</Text>
            <Text>{dayjs(record?.created_at).format('HH:mm')}</Text>
          </Space>
        );
      },
    },

    // {
    //   title: <IntlMessages id="global.id_number" />,
    //   key: 'id',
    //   width: 20,
    //   sorter: true,
    //   dataIndex: 'id',
    //   render: (text, record, index) => {
    //     return record.id;
    //   },
    // },
  ];

  return (
    <Card bordered={false} style={{ minHeight: '100%' }}>
      <Row justify="space-between">
        <Col>
          {' '}
          <PageTitle title={<IntlMessages id="global.account" />} />
        </Col>

        <Col>
          <ActionBar
            onDelete={() => onDelete(selectedRowKeys)}
            isShowAddButton={true}
            onAdd={onOpenModal}
            onRefresh={() => onReload()}
            isShowPublishButtons={false}
            deleteMessage={
              'Warning! You are about to delete this user and its associated records. Are you sure you want to delete this record?'
            }
            isShowCopyButton={false}
            isShowDeleteButton={true}
            isDisabled={!(selectedRowKeys.length > 0)}></ActionBar>
        </Col>
      </Row>

      <FilterBar onFilter={onFilter}></FilterBar>

      <br />

      <Table
        tableLayout="auto"
        columns={columns}
        dataSource={items}
        onChange={onChangeTable}
        rowKey="id"
        size="small"
        loading={loading}
        scroll={{
          x: 'max-content',
        }}
        pagination={{
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50'],
          total: total,
          current: filter.page,
          pageSize: filter.limit,
        }}
        rowSelection={rowSelection}
      />

      {modal ? (
        <UsersForm
          open={modal}
          onClose={onCloseModal}
          currentData={item}
          onReload={onReload}
          isAdmin={true}
        />
      ) : null}
    </Card>
  );
}

export default UsersAdmin;
